'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const iconButton = "_icon-button_1o2mv_1";
const styles = {
	iconButton: iconButton
};

const IconButton = (_a) => {
  var { className, isDisabled = false, name, size = "medium", style, variant = "primary" } = _a, props = tslib_es6.__rest(_a, ["className", "isDisabled", "name", "size", "style", "variant"]);
  return React__default.default.createElement(
    reactAriaComponents.Button,
    Object.assign({}, props, { className: clsx.clsx(className, styles.iconButton), "data-variant": variant, "data-size": size, "data-zds": true, isDisabled, style }),
    React__default.default.createElement(designSystem.Icon, { name, size: 24 })
  );
};

exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.cjs.js.map
